import { app } from '../../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.saaspass-users.user-labels.import-users-to-label', {
        url: '/import',
        params: {users: [],labels:[]},
        views: {
            '@company': 'companyUserLabelMembersImport'
        },
        resolve: {
            regCompanyUsers,
			labels
        },
    });
}

/** @ngInject */
function regCompanyUsers(companyId, UsersResource) {
    return UsersResource.getAllRegularCompanyUsers(companyId, 'all');
}


/** @ngInject */
function labels($stateParams) {
    return $stateParams.labels;
}






// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/saaspass-users/user-labels/import/import-users-to-label.state.js